import React from 'react';
import Cookies from 'js-cookie';
import { ActivityCalendar } from 'react-activity-calendar';
import { FiActivity, FiAward, FiBox, FiBriefcase, FiCalendar, FiCheckCircle, FiCheckSquare, FiClock, FiHeart, FiLoader, FiLogOut, FiMapPin, FiMoreVertical, FiPlus, FiSend, FiThumbsUp, FiTrendingUp, FiUser, FiUserPlus, FiX, FiUsers, FiVideo, FiClipboard, FiCircle, FiStar } from 'react-icons/fi';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import styles from '../Dashboard.module.css';
import * as utils from '../../../utils/utils';
import Sidebar from '../../Sidebar/Sidebar';
import HQDialog from '../../HQDialog/HQDialog';
import HQToast from '../../HQToast/HQToast';

export default class DashboardCheckIns extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            nickname: this.props.nickname || '',
            isSelf: this.props.isSelf || false,

            isLoadingLiveResumes: true,

            isLoadingMoreLiveResumes: false,
            errorText: '',

            openLiveResumeMenuID: 0,

            deletingLiveResumeIDs: [],
            deletingLiveResumeChatterIDs: [],
            isSendingLiveResumeReplyIDs: [],
            isSendingLiveResumeCommentIDs: [],
            isSendingLiveResumeEmoteIDs: [],
            replyTextByLiveResumeChatterID: {},
            commentTextByLiveResumeID: {},
            openLiveResumeReplyComposerID: 0,
            openLiveResumeCommentComposerID: 0,
            openLiveResumeChatterMenuID: 0,

            confirmDeleteLiveResumeID: 0,
            confirmDeleteLiveResumeChatterID: 0,

            contributionGraph: {},
            totalContributions: 0,
            recentLiveResumes: [],

            offset: 0,
            limit: 5,
            hasMore: false,
        };

        this.liveResumeMenuRefs = {};
        this.liveResumeChatterMenuRefs = {};
    }

    componentDidMount() {
        if (!utils.isLoggedIn()) {
            window.location.href = '/signin';
            return;
        }

        document.addEventListener('mousedown', this.onDocumentPointerDown);
        document.addEventListener('touchstart', this.onDocumentPointerDown);

        this.loadCheckIns();
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onDocumentPointerDown);
        document.removeEventListener('touchstart', this.onDocumentPointerDown);
    }

    // normalizeCalendarData = (graph) => {
    // 	const maxCount = graph.reduce((max, item) => {
    // 		return Math.max(max, item.count || 0);
    // 	}, 0);

    // 	return graph.map((item) => {
    // 		const count = Number(item.count) || 0;

    // 		let level = 0;
    // 		if (count > 0 && maxCount > 0) {
    // 			level = Math.min(4, Math.max(1, Math.ceil((count / maxCount) * 4)));
    // 		}

    // 		return {
    // 			date: item.day,
    // 			count,
    // 			level,
    // 		};
    // 	});
    // };

    loadCheckIns = () => {
        const userID = utils.getCurrentUserID();

        if (!Number.isInteger(userID) || userID <= 0) {
            this.setState({
                isLoadingLiveResumes: false,
                errorText: 'Could not identify your account. Please sign in again.',
            });
            return;
        }

        Promise.all([
            utils.sendRequest('/profile/getUserContributionGraph', { nickname: this.state.nickname }),
            utils.sendRequest('/liveResume/getRecentLiveResumeUpdates', { nickname: this.state.nickname, offset: 0 }),
        ])
            .then(([
                contributionResponse,
                updatesResponse
            ]) => {
                // const contributionGraph = this.normalizeCalendarData(contributionResponse.contributionGraph || []);
                const contributionGraph = contributionResponse || {};

                const recentLiveResumes = updatesResponse.recentLiveResumes || [];

                this.setState({
                    isLoadingLiveResumes: false,
                    errorText: '',

                    contributionGraph,
                    totalContributions: contributionResponse.totalContributions || 0,
                    recentLiveResumes,

                    offset: recentLiveResumes.length,
                    limit: updatesResponse.limit || 5,
                    hasMore: recentLiveResumes.length === (updatesResponse.limit || 5),
                });
            })
            .catch((error) => {
                console.log('dashboard load error', error);

                this.setState({
                    isLoadingLiveResumes: false,
                    errorText: 'Could not load dashboard data right now. Please try again shortly.',
                });
            });
    };

    isLiveResumeDeleting = (liveResumeID) => {
        return (this.state.deletingLiveResumeIDs || []).includes(liveResumeID);
    };

    setLiveResumeMenuRef = (liveResumeID, node) => {
        if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
            return;
        }

        if (node) {
            this.liveResumeMenuRefs[liveResumeID] = node;
            return;
        }

        delete this.liveResumeMenuRefs[liveResumeID];
    };

    setLiveResumeChatterMenuRef = (liveResumeChatterID, node) => {
        if (!Number.isInteger(liveResumeChatterID) || liveResumeChatterID <= 0) {
            return;
        }

        if (node) {
            this.liveResumeChatterMenuRefs[liveResumeChatterID] = node;
            return;
        }

        delete this.liveResumeChatterMenuRefs[liveResumeChatterID];
    };

    onDocumentPointerDown = (event) => {
        const openLiveResumeMenuID = Number(this.state.openLiveResumeMenuID);
        const openLiveResumeChatterMenuID = Number(this.state.openLiveResumeChatterMenuID);

        if (Number.isInteger(openLiveResumeMenuID) && openLiveResumeMenuID > 0) {
            const activeMenuRoot = this.liveResumeMenuRefs[openLiveResumeMenuID];

            if (!activeMenuRoot || !activeMenuRoot.contains(event.target)) {
                this.setState({
                    openLiveResumeMenuID: 0,
                });
            }
        }

        if (Number.isInteger(openLiveResumeChatterMenuID) && openLiveResumeChatterMenuID > 0) {
            const activeChatterMenuRoot = this.liveResumeChatterMenuRefs[openLiveResumeChatterMenuID];

            if (!activeChatterMenuRoot || !activeChatterMenuRoot.contains(event.target)) {
                this.setState({
                    openLiveResumeChatterMenuID: 0,
                });
            }
        }
    };

    toggleLiveResumeMenu = (liveResumeID) => {
        this.setState((prevState) => ({
            openLiveResumeMenuID: prevState.openLiveResumeMenuID === liveResumeID ? 0 : liveResumeID,
        }));
    };

    toggleLiveResumeChatterMenu = (liveResumeChatterID) => {
        if (!Number.isInteger(liveResumeChatterID) || liveResumeChatterID <= 0) {
            return;
        }

        this.setState((prevState) => ({
            openLiveResumeChatterMenuID: prevState.openLiveResumeChatterMenuID === liveResumeChatterID ? 0 : liveResumeChatterID,
        }));
    };

    isLiveResumeChatterDeleting = (liveResumeChatterID) => {
        return (this.state.deletingLiveResumeChatterIDs || []).includes(liveResumeChatterID);
    };

    isLiveResumeReplySending = (liveResumeChatterID) => {
        return (this.state.isSendingLiveResumeReplyIDs || []).includes(liveResumeChatterID);
    };

    isLiveResumeCommentSending = (liveResumeID) => {
        return (this.state.isSendingLiveResumeCommentIDs || []).includes(liveResumeID);
    };

    isLiveResumeEmoteSending = (liveResumeID) => {
        return (this.state.isSendingLiveResumeEmoteIDs || []).includes(liveResumeID);
    };

    onLiveResumeEmoteClick = (liveResumeIDInput) => {
        const liveResumeID = Number(liveResumeIDInput);

        if (!Number.isInteger(liveResumeID) || liveResumeID <= 0 || this.isLiveResumeEmoteSending(liveResumeID)) {
            return;
        }

        const currentUserID = utils.getCurrentUserID();
        const currentFirstName = utils.getUserFirstName() || '';
        const currentLastName = utils.getUserLastName() || '';

        this.setState((prevState) => ({
            isSendingLiveResumeEmoteIDs: Array.from(new Set([...(prevState.isSendingLiveResumeEmoteIDs || []), liveResumeID])),
            errorText: '',
        }), () => {
            utils.sendRequest('/liveResume/saveLiveResumeEmote', {
                userEntityLiveResumeID: liveResumeID,
            })
                .then(() => {
                    this.setState((prevState) => ({
                        recentLiveResumes: (prevState.recentLiveResumes || []).map((resume) => {
                            if (Number(resume.userEntityLiveResumeId) !== liveResumeID) {
                                return resume;
                            }

                            const currentEmotes = Array.isArray(resume.emotes) ? resume.emotes : [];
                            const hasCurrentUserEmote = currentEmotes.some((emote) => Number(emote.userId) === Number(currentUserID));

                            return {
                                ...resume,
                                emotes: hasCurrentUserEmote
                                    ? currentEmotes.filter((emote) => Number(emote.userId) !== Number(currentUserID))
                                    : [{
                                        userEntityLiveResumeEmoteId: Date.now(),
                                        userId: currentUserID,
                                        firstName: currentFirstName,
                                        lastName: currentLastName,
                                    }, ...currentEmotes],
                            };
                        }),
                        isSendingLiveResumeEmoteIDs: (prevState.isSendingLiveResumeEmoteIDs || []).filter((id) => id !== liveResumeID),
                    }));
                })
                .catch((error) => {
                    console.log('save live resume emote error', error);

                    this.setState((prevState) => ({
                        isSendingLiveResumeEmoteIDs: (prevState.isSendingLiveResumeEmoteIDs || []).filter((id) => id !== liveResumeID),
                        errorText: error && error.message ? error.message : 'Could not update like right now.',
                    }));
                });
        });
    };

    toggleLiveResumeCommentComposer = (liveResumeID) => {
        if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
            return;
        }

        this.setState((prevState) => {
            const shouldOpen = prevState.openLiveResumeCommentComposerID !== liveResumeID;

            return {
                openLiveResumeCommentComposerID: shouldOpen ? liveResumeID : 0,
                commentTextByLiveResumeID: shouldOpen
                    ? {
                        ...prevState.commentTextByLiveResumeID,
                        [liveResumeID]: prevState.commentTextByLiveResumeID[liveResumeID] || '',
                    }
                    : prevState.commentTextByLiveResumeID,
            };
        });
    };

    onLiveResumeCommentTextChange = (liveResumeID, event) => {
        const value = event && event.target ? event.target.value : '';

        this.setState((prevState) => ({
            commentTextByLiveResumeID: {
                ...prevState.commentTextByLiveResumeID,
                [liveResumeID]: value,
            },
        }));
    };

    onLiveResumeCommentSend = (liveResumeIDInput) => {
        const liveResumeID = Number(liveResumeIDInput);

        if (!Number.isInteger(liveResumeID) || liveResumeID <= 0 || this.isLiveResumeCommentSending(liveResumeID)) {
            return;
        }

        const commentText = ((this.state.commentTextByLiveResumeID || {})[liveResumeID] || '').trim();
        if (commentText === '') {
            this.setState({
                errorText: 'Please enter a comment before sending.',
            });
            return;
        }

        const currentUserID = utils.getCurrentUserID();
        const currentFirstName = utils.getUserFirstName() || '';
        const currentLastName = utils.getUserLastName() || '';

        this.setState((prevState) => ({
            isSendingLiveResumeCommentIDs: Array.from(new Set([...(prevState.isSendingLiveResumeCommentIDs || []), liveResumeID])),
            errorText: '',
        }), () => {
            utils.sendRequest('/liveResume/saveLiveResumeChatter', {
                chatterText: commentText,
                userEntityLiveResumeID: liveResumeID,
            })
                .then((responseData) => {
                    const insertedChatterIDRaw = Number(responseData && responseData.userEntityLiveResumeChatterId);
                    const insertedChatterID = Number.isInteger(insertedChatterIDRaw) && insertedChatterIDRaw > 0 ? insertedChatterIDRaw : Date.now();

                    const insertedComment = {
                        userEntityLiveResumeChatterId: insertedChatterID,
                        userEntityLiveResumeId: liveResumeID,
                        chatterText: commentText,
                        createdAt: new Date().toISOString(),
                        userId: currentUserID,
                        firstName: currentFirstName,
                        lastName: currentLastName,
                    };

                    this.setState((prevState) => ({
                        recentLiveResumes: (prevState.recentLiveResumes || []).map((resume) => {
                            if (Number(resume.userEntityLiveResumeId) !== liveResumeID) {
                                return resume;
                            }

                            const currentChatters = Array.isArray(resume.chatters) ? resume.chatters : [];

                            return {
                                ...resume,
                                chatters: [insertedComment, ...currentChatters],
                            };
                        }),
                        isSendingLiveResumeCommentIDs: (prevState.isSendingLiveResumeCommentIDs || []).filter((id) => id !== liveResumeID),
                        openLiveResumeCommentComposerID: 0,
                        commentTextByLiveResumeID: {
                            ...prevState.commentTextByLiveResumeID,
                            [liveResumeID]: '',
                        },
                    }));
                })
                .catch((error) => {
                    console.log('save live resume comment error', error);

                    this.setState((prevState) => ({
                        isSendingLiveResumeCommentIDs: (prevState.isSendingLiveResumeCommentIDs || []).filter((id) => id !== liveResumeID),
                        errorText: error && error.message ? error.message : 'Could not save comment right now.',
                    }));
                });
        });
    };

    toggleLiveResumeReplyComposer = (liveResumeChatterID) => {
        if (!Number.isInteger(liveResumeChatterID) || liveResumeChatterID <= 0) {
            return;
        }

        this.setState((prevState) => {
            const shouldOpen = prevState.openLiveResumeReplyComposerID !== liveResumeChatterID;

            return {
                openLiveResumeReplyComposerID: shouldOpen ? liveResumeChatterID : 0,
                replyTextByLiveResumeChatterID: shouldOpen
                    ? {
                        ...prevState.replyTextByLiveResumeChatterID,
                        [liveResumeChatterID]: prevState.replyTextByLiveResumeChatterID[liveResumeChatterID] || '',
                    }
                    : prevState.replyTextByLiveResumeChatterID,
            };
        });
    };

    onLiveResumeReplyTextChange = (liveResumeChatterID, event) => {
        const value = event && event.target ? event.target.value : '';

        this.setState((prevState) => ({
            replyTextByLiveResumeChatterID: {
                ...prevState.replyTextByLiveResumeChatterID,
                [liveResumeChatterID]: value,
            },
        }));
    };

    onLiveResumeReplySend = (liveResumeIDInput, parentChatter) => {
        const liveResumeID = Number(liveResumeIDInput);
        const parentLiveResumeChatterID = Number(parentChatter && parentChatter.userEntityLiveResumeChatterId);

        if (!Number.isInteger(liveResumeID) || liveResumeID <= 0 || !Number.isInteger(parentLiveResumeChatterID) || parentLiveResumeChatterID <= 0 || this.isLiveResumeReplySending(parentLiveResumeChatterID)) {
            return;
        }

        const replyText = ((this.state.replyTextByLiveResumeChatterID || {})[parentLiveResumeChatterID] || '').trim();
        if (replyText === '') {
            this.setState({
                errorText: 'Please enter a reply before sending.',
            });
            return;
        }

        const currentUserID = utils.getCurrentUserID();
        const currentFirstName = utils.getUserFirstName() || '';
        const currentLastName = utils.getUserLastName() || '';

        this.setState((prevState) => ({
            isSendingLiveResumeReplyIDs: Array.from(new Set([...(prevState.isSendingLiveResumeReplyIDs || []), parentLiveResumeChatterID])),
            errorText: '',
        }), () => {
            utils.sendRequest('/liveResume/saveLiveResumeChatter', {
                chatterText: replyText,
                userEntityLiveResumeID: liveResumeID,
                userEntityLiveResumeChatterID: parentLiveResumeChatterID,
            })
                .then((responseData) => {
                    const insertedChatterIDRaw = Number(responseData && responseData.userEntityLiveResumeChatterId);
                    const insertedChatterID = Number.isInteger(insertedChatterIDRaw) && insertedChatterIDRaw > 0 ? insertedChatterIDRaw : Date.now();

                    const insertedReply = {
                        userEntityLiveResumeChatterId: insertedChatterID,
                        userEntityLiveResumeId: liveResumeID,
                        chatterText: replyText,
                        createdAt: new Date().toISOString(),
                        userId: currentUserID,
                        firstName: currentFirstName,
                        lastName: currentLastName,
                    };

                    this.setState((prevState) => ({
                        recentLiveResumes: (prevState.recentLiveResumes || []).map((resume) => {
                            if (Number(resume.userEntityLiveResumeId) !== liveResumeID) {
                                return resume;
                            }

                            const currentChatters = Array.isArray(resume.chatters) ? resume.chatters : [];

                            return {
                                ...resume,
                                chatters: [insertedReply, ...currentChatters],
                            };
                        }),
                        isSendingLiveResumeReplyIDs: (prevState.isSendingLiveResumeReplyIDs || []).filter((id) => id !== parentLiveResumeChatterID),
                        openLiveResumeReplyComposerID: 0,
                        replyTextByLiveResumeChatterID: {
                            ...prevState.replyTextByLiveResumeChatterID,
                            [parentLiveResumeChatterID]: '',
                        },
                    }));
                })
                .catch((error) => {
                    console.log('save live resume reply error', error);

                    this.setState((prevState) => ({
                        isSendingLiveResumeReplyIDs: (prevState.isSendingLiveResumeReplyIDs || []).filter((id) => id !== parentLiveResumeChatterID),
                        errorText: error && error.message ? error.message : 'Could not send reply right now.',
                    }));
                });
        });
    };

    openDeleteLiveResumeChatterDialog = (liveResumeChatter) => {
        const liveResumeChatterID = Number(liveResumeChatter && liveResumeChatter.userEntityLiveResumeChatterId);

        if (!Number.isInteger(liveResumeChatterID) || liveResumeChatterID <= 0 || this.isLiveResumeChatterDeleting(liveResumeChatterID)) {
            return;
        }

        this.setState({
            openLiveResumeChatterMenuID: 0,
            confirmDeleteLiveResumeChatterID: liveResumeChatterID,
        });
    };

    closeDeleteLiveResumeChatterDialog = () => {
        this.setState({
            confirmDeleteLiveResumeChatterID: 0,
        });
    };

    onDeleteLiveResumeChatterDialogPrimaryClick = () => {
        const liveResumeChatterID = Number(this.state.confirmDeleteLiveResumeChatterID);

        this.setState({
            confirmDeleteLiveResumeChatterID: 0,
        }, () => {
            this.deleteLiveResumeChatter(liveResumeChatterID);
        });
    };

    deleteLiveResumeChatter = (liveResumeChatterIDInput) => {
        const liveResumeChatterID = Number(liveResumeChatterIDInput);

        if (!Number.isInteger(liveResumeChatterID) || liveResumeChatterID <= 0 || this.isLiveResumeChatterDeleting(liveResumeChatterID)) {
            return;
        }

        this.setState((prevState) => ({
            openLiveResumeChatterMenuID: 0,
            confirmDeleteLiveResumeChatterID: 0,
            deletingLiveResumeChatterIDs: Array.from(new Set([...(prevState.deletingLiveResumeChatterIDs || []), liveResumeChatterID])),
            errorText: '',
        }), () => {
            utils.sendRequest('/liveResume/deleteLiveResumeChatter', {
                userEntityLiveResumeChatterID: liveResumeChatterID,
            })
                .then(() => {
                    this.setState((prevState) => ({
                        recentLiveResumes: (prevState.recentLiveResumes || []).map((resume) => ({
                            ...resume,
                            chatters: (Array.isArray(resume.chatters) ? resume.chatters : []).filter((chatter) => Number(chatter.userEntityLiveResumeChatterId) !== liveResumeChatterID),
                        })),
                        deletingLiveResumeChatterIDs: (prevState.deletingLiveResumeChatterIDs || []).filter((id) => id !== liveResumeChatterID),
                    }));
                })
                .catch((error) => {
                    console.log('delete live resume chatter error', error);

                    this.setState((prevState) => ({
                        deletingLiveResumeChatterIDs: (prevState.deletingLiveResumeChatterIDs || []).filter((id) => id !== liveResumeChatterID),
                        errorText: error && error.message ? error.message : 'Could not delete the comment right now.',
                    }));
                });
        });
    };

    openDeleteLiveResumeDialog = (item) => {
        const liveResumeID = Number(item.userEntityLiveResumeId);

        if (!Number.isInteger(liveResumeID) || liveResumeID <= 0 || this.isLiveResumeDeleting(liveResumeID)) {
            return;
        }

        this.setState({
            openLiveResumeMenuID: 0,
            confirmDeleteLiveResumeID: liveResumeID,
        });
    };

    closeDeleteLiveResumeDialog = () => {
        this.setState({
            confirmDeleteLiveResumeID: 0,
        });
    };

    onDeleteLiveResumeDialogPrimaryClick = () => {
        const liveResumeID = Number(this.state.confirmDeleteLiveResumeID);

        this.setState({
            confirmDeleteLiveResumeID: 0,
        }, () => {
            this.deleteLiveResume(liveResumeID);
        });
    };

    deleteLiveResume = (liveResumeIDInput) => {
        const liveResumeID = Number(liveResumeIDInput);

        if (!Number.isInteger(liveResumeID) || liveResumeID <= 0 || this.isLiveResumeDeleting(liveResumeID)) {
            return;
        }

        this.setState((prevState) => ({
            openLiveResumeMenuID: 0,
            confirmDeleteLiveResumeID: 0,
            deletingLiveResumeIDs: Array.from(new Set([...prevState.deletingLiveResumeIDs, liveResumeID])),
            errorText: '',
        }), () => {
            utils.sendRequest('/liveResume/deleteLiveResume', {
                userEntityLiveResumeID: liveResumeID,
            })
                .then(() => {
                    this.setState((prevState) => ({
                        recentLiveResumes: prevState.recentLiveResumes.filter((resume) => Number(resume.userEntityLiveResumeId) !== liveResumeID),
                        deletingLiveResumeIDs: prevState.deletingLiveResumeIDs.filter((resumeID) => resumeID !== liveResumeID),
                    }));
                })
                .catch((error) => {
                    console.log('delete live resume error', error);

                    this.setState((prevState) => ({
                        deletingLiveResumeIDs: prevState.deletingLiveResumeIDs.filter((resumeID) => resumeID !== liveResumeID),
                        errorText: error && error.message ? error.message : 'Could not delete the live resume right now.',
                    }));
                });
        });
    };

    loadMoreUpdates = () => {
        const {
            limit,
            isLoadingMoreLiveResumes,
            nickname,
        } = this.state;

        if (isLoadingMoreLiveResumes) {
            return;
        }

        const userID = utils.getCurrentUserID();
        if (!Number.isInteger(userID) || userID <= 0) {
            return;
        }

        this.setState({
            isLoadingMoreLiveResumes: true,
        }, () => {
            utils.sendRequest('/liveResume/getRecentLiveResumeUpdates', {
                nickname,
                offset: this.state.offset,
            })
                .then((responseData) => {
                    const nextItems = responseData.recentLiveResumes || [];
                    const nextLimit = responseData.limit || limit;

                    this.setState((prevState) => ({
                        isLoadingMoreLiveResumes: false,
                        recentLiveResumes: [...prevState.recentLiveResumes, ...nextItems],
                        offset: prevState.offset + nextItems.length,
                        limit: nextLimit,
                        hasMore: nextItems.length === nextLimit,
                    }));
                })
                .catch((error) => {
                    console.log('load more updates error', error);
                    this.setState({
                        isLoadingMoreLiveResumes: false,
                    });
                });
        });
    };

    // getLatestActiveDate = () => {
    // 	const {
    // 		contributionGraph,
    // 	} = this.state;

    // 	for (let index = contributionGraph.length - 1; index >= 0; index--) {
    // 		if ((contributionGraph[index].count || 0) > 0) {
    // 			return contributionGraph[index].date;
    // 		}
    // 	}

    // 	return 'No activity yet';
    // };

    formatDate = (value) => {
        if (!value) {
            return 'Unknown';
        }

        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return 'Unknown';
        }

        return date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            // day: 'numeric', // don't show day
        });
    };

    formatDateTime = (value) => {
        if (!value) {
            return 'Unknown';
        }

        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return 'Unknown';
        }

        return date.toLocaleString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
        });
    };

    getInitials = (firstName, lastName) => {
        const first = (firstName || '').trim();
        const last = (lastName || '').trim();

        const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
        if (initials !== '') {
            return initials;
        }

        if (first !== '') {
            return first.slice(0, 2).toUpperCase();
        }

        return 'AN';
    };

    getChipNames = (items) => {
        if (!items || items.length === 0) {
            return [];
        }

        return items.map((item) => item.name).filter(Boolean);
    };

    getLiveResumeChatterText = (chatter) => {
        if (!chatter) {
            return '';
        }

        if (typeof chatter.chatterText === 'string') {
            return chatter.chatterText;
        }

        if (typeof chatter.liveResumeChatterText === 'string') {
            return chatter.liveResumeChatterText;
        }

        return '';
    };

    getConnectionInitials = (connection) => {
        if (connection && connection.firstName && connection.lastName) {
            return this.getInitials(connection.firstName, connection.lastName);
        }
        else {
            return this.getInitials(connection.nickname, '');
        }
    };

    getLiveResumeEmoteInitials = (emote) => {
        return this.getInitials(emote && emote.firstName, emote && emote.lastName);
    };

    getVerifiedStatus = (verificationTypeId) => {
        verificationTypeId = Number(verificationTypeId);
        if (verificationTypeId === 2) {
            return (
                <>
                    <FiClipboard />
                    Quiz Verified
                </>
            );
        }
        else if (verificationTypeId === 3) {
            return (
                <>
                    <FiVideo />
                    Video Verified
                </>
            );
        }
        else if (verificationTypeId === 4) {
            return (
                <>
                    <FiUsers />
                    Vouch Verified
                </>
            );
        }

        return (
            <>
                <FiCircle />
                Not Yet Verified
            </>
        );
    };

    renderScoreChip = (item) => {
        if (!this.state.isSelf) {
            return null;
        }

        const score = Number(item.liveResumeScoreTypeId) - 1;
        return (
            <span className={styles.metaChip}>
                {
                    Array.from({ length: 3 }, (_, index) => {
                        const isFilled = index < score;
                        return (
                            <FiStar
                                key={`score-${item.userEntityLiveResumeId}-${index}`}
                                fill={isFilled ? 'currentColor' : 'none'}
                            />
                        );
                    })
                }
                {item.score}
            </span>
        );
    };

    renderUpdateCard = (item) => {
        const liveResumeID = Number(item.userEntityLiveResumeId);
        const skillNames = this.getChipNames(item.skills);
        const toolNames = this.getChipNames(item.tools);
        const domainNames = this.getChipNames(item.domains);
        const softSkillNames = this.getChipNames(item.softSkills);
        const impacts = this.getChipNames(item.impacts);
        const achievements = this.getChipNames(item.achievements);
        const chatters = Array.isArray(item.chatters) ? item.chatters : [];
        const emotes = Array.isArray(item.emotes) ? item.emotes : [];
        const liveResumeConnections = Array.isArray(item.liveResumeConnections) ? item.liveResumeConnections : [];
        //  (item.chatters || [])
        // 	.filter((chatter) => chatter && typeof chatter.chatterText === 'string' && chatter.chatterText.trim() !== '')
        // 	.slice()
        // 	.sort((a, b) => {
        // 		const aTime = new Date(a.createdAt || 0).getTime();
        // 		const bTime = new Date(b.createdAt || 0).getTime();

        // 		if (Number.isNaN(aTime) && Number.isNaN(bTime)) {
        // 			return 0;
        // 		}

        // 		if (Number.isNaN(aTime)) {
        // 			return -1;
        // 		}

        // 		if (Number.isNaN(bTime)) {
        // 			return 1;
        // 		}

        // 		return aTime - bTime;
        // 	});
        const isMenuOpen = this.state.openLiveResumeMenuID === liveResumeID;
        const isDeleting = this.isLiveResumeDeleting(liveResumeID);
        const currentUserID = utils.getCurrentUserID();
        const isEmoteSending = this.isLiveResumeEmoteSending(liveResumeID);
        const hasCurrentUserEmote = emotes.some((emote) => Number(emote.userId) === Number(currentUserID));
        const isCommentComposerOpen = this.state.openLiveResumeCommentComposerID === liveResumeID;
        const isCommentSending = this.isLiveResumeCommentSending(liveResumeID);
        const commentText = (this.state.commentTextByLiveResumeID || {})[liveResumeID] || '';

        return (
            <article key={item.userEntityLiveResumeId} className={`${styles.updateCard}${isDeleting ? ` ${styles.updateCardDeleting}` : ''}`}>
                <div className={styles.updateTopRow}>
                    <div className={styles.updateMetaGroup}>
                        {this.renderScoreChip(item)}
                        <span className={styles.metaChip}><FiBox /> {item.careerCategoryName || 'Category Set'}</span>
                        {/* <span className={styles.metaChip}><FiMapPin /> {item.location || 'Remote'}</span> */}
                        <span className={styles.metaChip}><FiClock /> {this.formatDate(item.createdAt)}</span>
                        <span className={styles.metaChip}>{this.getVerifiedStatus(item.liveResumeVerificationTypeId)}</span>
                    </div>
                    <div className={styles.updateActions} ref={(node) => this.setLiveResumeMenuRef(liveResumeID, node)}>
                        <button
                            type="button"
                            className={styles.updateMenuButton}
                            onClick={() => this.toggleLiveResumeMenu(liveResumeID)}
                            aria-label="Open live resume actions"
                            aria-expanded={isMenuOpen}
                            disabled={isDeleting}
                        >
                            <FiMoreVertical />
                        </button>

                        {isMenuOpen && (
                            <div className={styles.updateMenu} role="menu" aria-label="Live resume actions">
                                <button
                                    type="button"
                                    className={styles.updateMenuItemDelete}
                                    onClick={() => this.openDeleteLiveResumeDialog(item)}
                                    disabled={isDeleting}
                                    role="menuitem"
                                >
                                    Delete
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <p className={styles.liveResumeText}>{item.liveResumeText || 'No live resume update text available.'}</p>

                {(
                    domainNames.length > 0 ||
                    skillNames.length > 0 ||
                    toolNames.length > 0 ||
                    softSkillNames.length > 0 ||
                    impacts.length > 0 ||
                    achievements.length > 0
                ) && (
                        <div className={styles.tagWrapperGrid}>
                            {domainNames.length > 0 &&
                                <div className={styles.tagBlock}>
                                    <h4 className={styles.tagHeading}>Domains</h4>
                                    <div className={styles.tagRow}>
                                        {domainNames.map((name) => <span key={`domain-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
                                    </div>
                                </div>
                            }

                            {skillNames.length > 0 &&
                                <div className={styles.tagBlock}>
                                    <h4 className={styles.tagHeading}>Skills</h4>
                                    <div className={styles.tagRow}>
                                        {skillNames.map((name) => <span key={`skill-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
                                    </div>
                                </div>
                            }

                            {toolNames.length > 0 &&
                                <div className={styles.tagBlock}>
                                    <h4 className={styles.tagHeading}>Tools</h4>
                                    <div className={styles.tagRow}>
                                        {toolNames.map((name) => <span key={`tool-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
                                    </div>
                                </div>
                            }

                            {softSkillNames.length > 0 &&
                                <div className={styles.tagBlock}>
                                    <h4 className={styles.tagHeading}>Soft Skills</h4>
                                    <div className={styles.tagRow}>
                                        {softSkillNames.map((name) => <span key={`soft-skill-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
                                    </div>
                                </div>
                            }

                            {impacts.length > 0 &&
                                <div className={styles.tagBlock}>
                                    <h4 className={styles.tagHeading}>Impacts</h4>
                                    <div className={styles.tagRow}>
                                        {impacts.map((name) => <span key={`impact-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
                                    </div>
                                </div>
                            }

                            {achievements.length > 0 &&
                                <div className={styles.tagBlock}>
                                    <h4 className={styles.tagHeading}>Achievements</h4>
                                    <div className={styles.tagRow}>
                                        {achievements.map((name) => <span key={`achievement-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
                                    </div>
                                </div>
                            }

                        </div>
                    )}

                    {liveResumeConnections.length > 0 && (
                        <section className={styles.tagWrapperGrid}>
                            <div className={styles.tagBlock}>
                                <h4 className={styles.tagHeading}>People doing similar</h4>
                                <div className={styles.liveResumeConnectionAvatars}>
                                    {liveResumeConnections.map((connection) => {
                                        const nickname = (connection.nickname || '').trim();
                                        // const displayName = `${(connection.firstName || '').trim()} ${(connection.lastName || '').trim()}`.trim() || nickname || 'Member';
                                        return (
                                            <a
                                                key={`connection-${liveResumeID}-${nickname}`}
                                                className={styles.liveResumeConnectionAvatar}
                                                href={`/@${encodeURIComponent(nickname)}`}
                                            >
                                                {this.getConnectionInitials(connection)}
                                            </a>
                                        );
                                    })}
                                </div>
                            </div>
                        </section>
                    )}

                    {/* todo <div className={styles.liveResumeEmoteSection}>
                        <button
                            type="button"
                            className={`${styles.liveResumeEmoteButton}${hasCurrentUserEmote ? ` ${styles.liveResumeEmoteButtonActive}` : ''}`}
                            onClick={() => this.onLiveResumeEmoteClick(liveResumeID)}
                            disabled={isEmoteSending}
                            aria-label={hasCurrentUserEmote ? 'Remove like' : 'Like this live resume'}
                        >
                            <FiHeart size={20} stroke="var(--text-secondary)" fill={hasCurrentUserEmote ? 'currentColor' : 'none'} />
                        </button>

                        <div className={styles.liveResumeEmoteMeta}>
                            <div className={styles.liveResumeEmoteAvatars}>
                                {emotes.slice(0, 4).map((emote) => (
                                    <span key={`emote-${item.userEntityLiveResumeId}-${emote.userEntityLiveResumeEmoteId}`} className={styles.liveResumeEmoteAvatar} title={`${emote.firstName || ''} ${emote.lastName || ''}`.trim() || 'Member'}>
                                        {this.getLiveResumeEmoteInitials(emote)}
                                    </span>
                                ))}
                            </div>
                            {/* <span className={styles.liveResumeEmoteLabel}>
                                {emotes.length > 0 ? `${emotes.length} like${emotes.length === 1 ? '' : 's'}` : 'Be the first to like this'}
                            </span> *}
                        </div>
                    </div> */}

                <section className={styles.liveResumeCommentsSection}>
                    <h4 className={styles.liveResumeCommentsTitle}>Comments</h4>

                    <div className={styles.profileCardMetaRow}>
                        <button
                            type="button"
                            className={styles.secondaryButton}
                            onClick={() => this.toggleLiveResumeCommentComposer(liveResumeID)}
                            disabled={isCommentSending}
                        >
                            <FiPlus /> {isCommentComposerOpen ? 'Cancel Comment' : 'Add Comment'}
                        </button>
                        {/* <button
                            type="button"
                            className={styles.chatterReplyButton}
                            onClick={() => this.toggleLiveResumeCommentComposer(liveResumeID)}
                            disabled={isCommentSending}
                        >
                            {isCommentComposerOpen ? 'Cancel Comment' : 'Add Comment'}
                        </button> */}
                    </div>

                    {isCommentComposerOpen && (
                        <div className={styles.chatterReplyComposer}>
                            <textarea
                                className={styles.dialogTextarea}
                                value={commentText}
                                onChange={(event) => this.onLiveResumeCommentTextChange(liveResumeID, event)}
                                placeholder="Write your comment..."
                                rows={3}
                            />
                            <div className={styles.chatterReplyComposerActions}>
                                <button
                                    type="button"
                                    className={styles.primaryButton}
                                    onClick={() => this.onLiveResumeCommentSend(liveResumeID)}
                                    disabled={isCommentSending}
                                >
                                    {isCommentSending ? 'Sending...' : (<><FiSend /> Send Comment</>)}
                                </button>
                            </div>
                        </div>
                    )}

                    {chatters.length === 0 && (
                        <div className={styles.emptyBox}>No comments yet. Be the first to comment.</div>
                    )}

                    {chatters.length > 0 && (
                        <div className={styles.liveResumeCommentsList}>
                            {chatters.map((chatter) => {
                                const chatterID = Number(chatter.userEntityLiveResumeChatterId);
                                const isReplyComposerOpen = this.state.openLiveResumeReplyComposerID === chatterID;
                                const isReplySending = this.isLiveResumeReplySending(chatterID);
                                const replyText = (this.state.replyTextByLiveResumeChatterID || {})[chatterID] || '';
                                const isChatterMenuOpen = this.state.openLiveResumeChatterMenuID === chatterID;
                                const canDeleteChatter = Number(chatter.userId) === Number(currentUserID);
                                const isChatterDeleting = this.isLiveResumeChatterDeleting(chatterID);
                                const chatterText = this.getLiveResumeChatterText(chatter);
                                const authorName = `${chatter.firstName || ''} ${chatter.lastName || ''}`.trim() || 'Anonymous';

                                return (
                                    <div
                                        key={`chatter-${chatter.userEntityLiveResumeChatterId}`}
                                        className={styles.liveResumeCommentCard}
                                    >
                                        <div className={styles.liveResumeCommentHeader}>
                                            <div className={styles.liveResumeCommentAuthor}>
                                                <span className={styles.liveResumeCommentAvatar}>{this.getInitials(chatter.firstName, chatter.lastName)}</span>
                                                <div className={styles.liveResumeCommentIdentity}>
                                                    <p className={styles.liveResumeCommentName}>{authorName}</p>
                                                    <p className={styles.liveResumeCommentMeta}>{this.formatDateTime(chatter.createdAt)}</p>
                                                </div>
                                            </div>

                                            {canDeleteChatter && (
                                                <div className={styles.updateActions} ref={(node) => this.setLiveResumeChatterMenuRef(chatterID, node)}>
                                                    <button
                                                        type="button"
                                                        className={styles.updateMenuButton}
                                                        onClick={() => this.toggleLiveResumeChatterMenu(chatterID)}
                                                        aria-label="Open comment actions"
                                                        aria-expanded={isChatterMenuOpen}
                                                        disabled={isChatterDeleting}
                                                    >
                                                        <FiMoreVertical />
                                                    </button>

                                                    {isChatterMenuOpen && (
                                                        <div className={styles.updateMenu} role="menu" aria-label="Comment actions">
                                                            <button
                                                                type="button"
                                                                className={styles.updateMenuItemDelete}
                                                                onClick={() => this.openDeleteLiveResumeChatterDialog(chatter)}
                                                                disabled={isChatterDeleting}
                                                                role="menuitem"
                                                            >
                                                                Delete
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <p className={styles.liveResumeCommentText}>{chatterText || 'Comment not available.'}</p>

                                        <div className={styles.profileCardMetaRow}>
                                            {/* <button
												type="button"
												className={styles.chatterReplyButton}
												onClick={() => this.toggleLiveResumeReplyComposer(chatterID)}
												disabled={isReplySending}
											>
												{isReplyComposerOpen ? 'Cancel Reply' : 'Reply'}
											</button> */}
                                        </div>

                                        {isReplyComposerOpen && (
                                            <div className={styles.chatterReplyComposer}>
                                                <textarea
                                                    className={styles.dialogTextarea}
                                                    value={replyText}
                                                    onChange={(event) => this.onLiveResumeReplyTextChange(chatterID, event)}
                                                    placeholder="Write your reply..."
                                                    rows={3}
                                                />
                                                <div className={styles.chatterReplyComposerActions}>
                                                    <button
                                                        type="button"
                                                        className={styles.primaryButton}
                                                        onClick={() => this.onLiveResumeReplySend(liveResumeID, chatter)}
                                                        disabled={isReplySending}
                                                    >
                                                        {isReplySending ? 'Sending...' : (<><FiSend /> Send Reply</>)}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </section>
            </article>
        );
    };

    renderDeleteLiveResumeDialog = () => {
        const liveResumeID = Number(this.state.confirmDeleteLiveResumeID);

        if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
            return null;
        }

        return (
            <HQDialog
                title="Delete Live Resume"
                message="Are you sure you want to delete this live-resume?"
                primaryButtonText="Delete"
                onPrimaryClick={this.onDeleteLiveResumeDialogPrimaryClick}
                onCancelClick={this.closeDeleteLiveResumeDialog}
                isPrimaryDisabled={this.isLiveResumeDeleting(liveResumeID)}
            />
        );
    };

    renderDeleteLiveResumeChatterDialog = () => {
        const liveResumeChatterID = Number(this.state.confirmDeleteLiveResumeChatterID);

        if (!Number.isInteger(liveResumeChatterID) || liveResumeChatterID <= 0) {
            return null;
        }

        return (
            <HQDialog
                title="Delete Comment"
                message="Are you sure you want to delete this comment?"
                primaryButtonText="Delete"
                onPrimaryClick={this.onDeleteLiveResumeChatterDialogPrimaryClick}
                onCancelClick={this.closeDeleteLiveResumeChatterDialog}
                isPrimaryDisabled={this.isLiveResumeChatterDeleting(liveResumeChatterID)}
            />
        );
    };

    render() {
        const {
            isLoadingLiveResumes,
            isLoadingMoreLiveResumes,
            errorText,
            contributionGraph,
            totalContributions,
            recentLiveResumes,
            hasMore,
            numInvitesLeft,
            inviteCode,
        } = this.state;

        return (
            <>
                <div className={styles.sectionHeader}>
                    <h2 className={styles.formTitle}><FiUser /> Dashboard Overview</h2>
                    <p className={styles.formText}>Tracking real-time activity updates, growth trends, and live resume ledger.</p>
                </div>

                {errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}

                {isLoadingLiveResumes && <div className={styles.loadingBox}>Synchronizing profile indices...</div>}

                {!isLoadingLiveResumes && (
                    <>
                        <section className={styles.contentSection}>
                            <h3 className={styles.sectionTitle}>Activity Map</h3>
                            <div className={styles.activityCard}>
                                <div className={styles.activityHeader}>
                                    <div>
                                        <span className={styles.activityKpiLabel}>30-Day Momentum</span>
                                        <h4 className={styles.activityKpiValue}>{contributionGraph.totalContributions} Check-ins</h4>
                                    </div>
                                    {/* <span className={styles.activityTrend}>(tbd)+12% vs last month</span> */}
                                </div>

                                <div className={styles.activityChartContainer}>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart data={contributionGraph.contributionGraph}>
                                            {contributionGraph.categories.map((cat) => {
                                                const minHex = 7, maxHex = 15;
                                                const opacity1 = Math.floor(Math.random() * (maxHex - minHex + 1) + minHex).toString(16);
                                                const opacity2 = Math.random().toString(8).slice(2, 3);
                                                return (
                                                    <Bar
                                                        // barSize={10}
                                                        key={cat.careerCategoryId}
                                                        dataKey={`c_${cat.careerCategoryId}`}
                                                        name={cat.categoryName}
                                                        // fill={`#${cat.colorCode}`}
                                                        fill={`#2563eb${opacity1}${opacity2}`}
                                                        // fill={`#2563eb${darkHex}`}
                                                        stackId="a"
                                                    />
                                                );
                                            })}
                                        </BarChart>
                                        {/* <AreaChart data={this.sampleSparklineData} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
											<defs>
												<linearGradient id="activityGlow" x1="0" y1="0" x2="0" y2="1">
													<stop offset="5%" stopColor="#2563eb" stopOpacity={0.18} />
													<stop offset="95%" stopColor="#2563eb" stopOpacity={0} />
												</linearGradient>
											</defs>
											<XAxis dataKey="date" hide />
											<Tooltip
												contentStyle={{
													background: 'rgba(15, 23, 42, 0.95)',
													border: '1px solid rgba(255, 255, 255, 0.1)',
													borderRadius: '8px',
													color: '#ffffff',
													fontSize: '12px',
													fontFamily: "'JetBrains Mono', monospace",
													backdropFilter: 'blur(4px)'
												}}
												itemStyle={{ color: '#38bdf8' }}
											/>
											<Area
												type="linear"
												dataKey="checkins"
												stroke="#2563eb"
												strokeWidth={2.5}
												fillOpacity={1}
												fill="url(#activityGlow)"
											/>
										</AreaChart> */}
                                    </ResponsiveContainer>
                                </div>
                            </div>
                            {/* <ActivityCalendar
								data={contributionGraph}
								blockRadius={3}
								blockSize={12}
								blockMargin={4}
								showWeekdayLabels
								hideColorLegend
								theme={{
									light: ['#f1f5f9', '#cbd5e1', '#94a3b8', '#475569', '#0f172a'],
								}}
								labels={{
									totalCount: '{{count}} items log compiled over trailing 90 days',
								}}
							/> */}
                        </section>

                        <section className={styles.contentSection}>
                            <h3 className={styles.sectionTitle}>Live Resume Streams</h3>

                            {recentLiveResumes.length === 0 && (
                                <div className={styles.emptyBox}>Stream empty. Initialize live resume entries to populate ledger.</div>
                            )}

                            <div className={styles.updatesList}>
                                {recentLiveResumes.map(this.renderUpdateCard)}
                            </div>

                            {hasMore && (
                                <button
                                    className={styles.loadMoreButton}
                                    onClick={this.loadMoreUpdates}
                                    disabled={isLoadingMoreLiveResumes}
                                >
                                    {isLoadingMoreLiveResumes ? 'Reading Data...' : 'Fetch Older Entries'}
                                </button>
                            )}
                        </section>
                    </>
                )}

                {this.renderDeleteLiveResumeDialog()}
                {this.renderDeleteLiveResumeChatterDialog()}
            </>
        );
    };
};